<select class="form-control" [(ngModel)]="selectedValue">
    <option value=""></option>
    @for (value of allValues; track value) {
        <option [value]="value">{{ value }}</option>
    }
</select>
